import { render, staticRenderFns } from "./KoioteIBHLinkConnectionProperties.vue?vue&type=template&id=576ca8bc&lang=es&"
import script from "./KoioteIBHLinkConnectionProperties.vue?vue&type=script&lang=js&"
export * from "./KoioteIBHLinkConnectionProperties.vue?vue&type=script&lang=js&"
import style0 from "./KoioteIBHLinkConnectionProperties.vue?vue&type=style&index=0&id=576ca8bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports